(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('i18n', i18n);

  function i18n($filter) {

    var service = {
      translate: translate
    };

    return service;

    function translate(key) {
      return $filter('translate')(key);
    }
  }

})();
